"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var services_1 = require("stremio/services");
var tmdbApi_1 = require("stremio/common/tmdbApi");
var dataEnrichmentPrefs_1 = require("stremio/common/dataEnrichmentPrefs");
var useDataEnrichmentOptions = function (_a) {
    var profile = _a.profile;
    var core = (0, services_1.useServices)().core;
    var _b = (0, react_1.useState)(function () { return (0, tmdbApi_1.getTMDBApiKey)() || ''; }), apiKey = _b[0], setApiKeyState = _b[1];
    var _c = (0, dataEnrichmentPrefs_1.useDataEnrichmentPrefs)(), showTmdbCast = _c.showTmdbCast, showPosterRatings = _c.showPosterRatings, showTmdbDescription = _c.showTmdbDescription, showMaturityRating = _c.showMaturityRating, showSimilarTitles = _c.showSimilarTitles, setShowTmdbCast = _c.setShowTmdbCast, setShowPosterRatings = _c.setShowPosterRatings, setShowTmdbDescription = _c.setShowTmdbDescription, setShowMaturityRating = _c.setShowMaturityRating, setShowSimilarTitles = _c.setShowSimilarTitles;
    (0, react_1.useEffect)(function () {
        var handleStorageChange = function () {
            setApiKeyState((0, tmdbApi_1.getTMDBApiKey)() || '');
        };
        window.addEventListener('storage', handleStorageChange);
        return function () { return window.removeEventListener('storage', handleStorageChange); };
    }, []);
    var refreshApiKey = (0, react_1.useCallback)(function () {
        setApiKeyState((0, tmdbApi_1.getTMDBApiKey)() || '');
    }, []);
    var showTmdbCastToggle = (0, react_1.useMemo)(function () {
        var hasApiKey = apiKey && apiKey.trim().length > 0;
        return {
            checked: showTmdbCast,
            disabled: !hasApiKey,
            onClick: function () {
                if (hasApiKey) {
                    setShowTmdbCast(!showTmdbCast);
                    core.transport.dispatch({
                        action: 'Ctx',
                        args: {
                            action: 'UpdateSettings',
                            args: __assign(__assign({}, profile.settings), { showTmdbCast: !showTmdbCast })
                        }
                    });
                }
            }
        };
    }, [profile.settings, apiKey, showTmdbCast, setShowTmdbCast, core]);
    var showPosterRatingsToggle = (0, react_1.useMemo)(function () {
        return {
            checked: showPosterRatings,
            onClick: function () {
                setShowPosterRatings(!showPosterRatings);
                core.transport.dispatch({
                    action: 'Ctx',
                    args: {
                        action: 'UpdateSettings',
                        args: __assign(__assign({}, profile.settings), { showPosterRatings: !showPosterRatings })
                    }
                });
            }
        };
    }, [profile.settings, showPosterRatings, setShowPosterRatings, core]);
    var showTmdbDescriptionToggle = (0, react_1.useMemo)(function () {
        var hasApiKey = apiKey && apiKey.trim().length > 0;
        return {
            checked: showTmdbDescription,
            disabled: !hasApiKey,
            onClick: function () {
                if (hasApiKey) {
                    setShowTmdbDescription(!showTmdbDescription);
                    core.transport.dispatch({
                        action: 'Ctx',
                        args: {
                            action: 'UpdateSettings',
                            args: __assign(__assign({}, profile.settings), { showTmdbDescription: !showTmdbDescription })
                        }
                    });
                }
            }
        };
    }, [profile.settings, apiKey, showTmdbDescription, setShowTmdbDescription, core]);
    var showMaturityRatingToggle = (0, react_1.useMemo)(function () {
        var hasApiKey = apiKey && apiKey.trim().length > 0;
        return {
            checked: showMaturityRating,
            disabled: !hasApiKey,
            onClick: function () {
                if (hasApiKey) {
                    setShowMaturityRating(!showMaturityRating);
                    core.transport.dispatch({
                        action: 'Ctx',
                        args: {
                            action: 'UpdateSettings',
                            args: __assign(__assign({}, profile.settings), { showMaturityRating: !showMaturityRating })
                        }
                    });
                }
            }
        };
    }, [profile.settings, apiKey, showMaturityRating, setShowMaturityRating, core]);
    var showSimilarTitlesToggle = (0, react_1.useMemo)(function () {
        var hasApiKey = apiKey && apiKey.trim().length > 0;
        return {
            checked: showSimilarTitles,
            disabled: !hasApiKey,
            onClick: function () {
                if (hasApiKey) {
                    setShowSimilarTitles(!showSimilarTitles);
                    core.transport.dispatch({
                        action: 'Ctx',
                        args: {
                            action: 'UpdateSettings',
                            args: __assign(__assign({}, profile.settings), { showSimilarTitles: !showSimilarTitles })
                        }
                    });
                }
            }
        };
    }, [profile.settings, apiKey, showSimilarTitles, setShowSimilarTitles, core]);
    return {
        showTmdbCastToggle: showTmdbCastToggle,
        showPosterRatingsToggle: showPosterRatingsToggle,
        showTmdbDescriptionToggle: showTmdbDescriptionToggle,
        showMaturityRatingToggle: showMaturityRatingToggle,
        showSimilarTitlesToggle: showSimilarTitlesToggle,
        refreshApiKey: refreshApiKey,
    };
};
exports.default = useDataEnrichmentOptions;
